import { UserType } from '../types/userTypes'
import React from 'react'
import { AnalyticsContext } from './AnalyticsContext'
import { getParentWindowHostname } from '../wholesaler-integration/isWholesalerMode'
import { EventPageView } from './AnalyticsEvents'
import { BuildConfig } from '../config/BuildConfig'
import { getAnalyticsPageViewEnvironment } from '../environment'

export function usePageViewEvent(params: { userType: UserType | null, pageCategory: 'list' | 'selector' }) {
  const analyticsLogger = React.useContext(AnalyticsContext)

  React.useEffect(() => {
    const parentWindow = getParentWindowHostname()
    const hostname = parentWindow ?? window.location.hostname

    // Default to consumer if not yet set
    const pageSubCategory = params.userType === 'electrician' ? 'Electrician' : 'Home Owner'

    const pageView: EventPageView = {
      event: 'page_view',
      digital_platform: hostname,
      digital_platform_country: BuildConfig.brand.countryCode,
      environment: getAnalyticsPageViewEnvironment(),
      page_category: null,
      page_language: 'en',
      page_sub_category: pageSubCategory,
      page_sub_sub_category: null,
      page_top_category: params.pageCategory,
      template: 'configurator',
      business_unit: 'ENM Home Distribution',
      configurator_name: 'Iconic Product Builder',
      business_divison: '',
    }

    analyticsLogger.log(pageView)

    // This should only run once per load, or when userType changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.userType])
}